import React, { Component } from 'react';
import {TweenLite,TimelineLite,Sine,Expo,Power0,Power4} from 'gsap';
import ScrollToPlugin from "gsap/ScrollToPlugin";


class ScrollTo extends Component {

	
	constructor(props) {
    	super(props);
    	this.state = {ready:false};
	}

  init = () =>{
  		
  		
  		

  }

  
  componentDidMount() {

    let jump = this.props.jump ? true:false



    setTimeout(() => {



      let pos = 0;
      let el = document.querySelectorAll('.Site')[0];
    /*if(this.props.pos) pos = this.props.pos;
    let curScroll = el.scrollTop;

    


        if(el){

          let offset = el.getBoundingClientRect();
          let top = offset.top || offset.y;

          pos = curScroll + top;

        }

    

    if(this.props.plus) pos += this.props.plus;

    var dist = Math.abs(curScroll - pos);*/

    if(jump)
    {
      el.scrollTop = 0;
    } else {



    TweenLite.to(el, 0.5 , {scrollTo:{y:0, x:0},ease:Expo.easeInOut,onComplete:function(){
        //Site.Emitter.trigger('scrollComplete');
      }});

  }






    
  

    },0)
    
}


  render() {

    return (null);
  }
}

export default ScrollTo;



// WEBPACK FOOTER //
// ./src/js/components/ScrollTo/ScrollTo.js